import {DateToYYYYMMDD} from "../../../core/helpers/dates/datesHelper";
import {IIncident} from "../../../core/interfaces/incident";
import When from "../../../components/When";
import FormProvider from "./FormProvider/FormProvider";

export function ReportedDateForm(props: { newIncident: IIncident, isNewIncident: boolean }) {
    return <FormProvider controlId="formReportedDate" title="Rappoterat datum">
            <span className={'col-form-label'}>
                <When condition={props.isNewIncident} otherwise={DateToYYYYMMDD(props.newIncident.createdAt)}>
                    {DateToYYYYMMDD(new Date())}
                </When>
            </span>
    </FormProvider>
}